<div class="tile">
  <div class="row">
    <div class="col-12">
      <h1 class="zero-text p-huge-med">{{ 'savings-plan.savings-plan-subjects.headline' | transloco }}</h1>
      <p class="mt-2">{{ 'savings-plan.savings-plan-subjects.hint' | transloco }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-6 asset-search">
      <saving-plans-saving-plan-search (selectSavingsPlan)="useSavingsPlan($event)" />
    </div>
  </div>
  <div class="row mt-4">
    @for (currentType of types; track $index) {
      <div class="col-12 mb-2">
        <h5>{{ 'savings-plan.savings-plan-subjects.famous-' + currentType | transloco }}</h5>
        <hr />
        <table class="table-depot">
          <caption>
            Sparpläne Liste
          </caption>
          <thead>
            <tr>
              <th style="width: 50%">
                {{ 'savings-plan.savings-plan-subjects.table-head.name' | transloco }}
              </th>
              @if (currentType !== instrumentType.Crypto) {
                <th>
                  {{ 'savings-plan.savings-plan-subjects.table-head.isin' | transloco }}
                </th>
              }
              <th style="width: 10%"></th>
            </tr>
          </thead>
          <tbody>
            @for (instrument of (facade.mostChosenSavingPlans$ | async)[currentType]; track $index) {
              <tr>
                <td>
                  <div class="d-flex">
                    <web-components-instrument-details-link class="font-medium" [isin]="instrument.isin">
                      {{ instrument.name }}
                    </web-components-instrument-details-link>
                    <web-components-watchlist-toggle [isin]="instrument.isin" />
                  </div>
                  <a
                    class="link-primary color-secondary"
                    [href]="'https://www.finanzen.net/go/' + instrument.isin"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ 'savings-plan.savings-plan-subjects.links.info' | transloco }}
                  </a>
                </td>
                @if (currentType !== instrumentType.Crypto) {
                  <td>
                    <div class="d-flex justify-content-end">
                      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                        {{ 'savings-plan.savings-plan-subjects.table-head.isin' | transloco }}
                      </div>
                      <div class="text-right">{{ instrument.isin }}</div>
                    </div>
                  </td>
                }
                <td>
                  <div class="d-flex justify-content-end">
                    <div
                      class="trade savings-plan cursor-pointer"
                      title="Sparplan anlegen"
                      [routerLink]="savingPlanMaskUrl + '/' + instrument.isin"
                    >
                      <svg class="icon icon-24">
                        <use xlink:href="/assets/img/svgs/svgset.svg#pig" />
                      </svg>
                    </div>
                    <div
                      class="trade buy cursor-pointer"
                      title="Kaufen"
                      [routerLink]="orderMaskUrl"
                      [queryParams]="{
                        isin: instrument.isin,
                        direction: 'buy',
                      }"
                    >
                      K
                    </div>
                    <div
                      class="trade sell cursor-pointer"
                      title="Verkaufen"
                      [routerLink]="orderMaskUrl"
                      [queryParams]="{
                        isin: instrument.isin,
                        direction: 'sell',
                      }"
                    >
                      V
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
